module.exports = __webpack_public_path__ + "static/media/Logo.9afd6da4.svg";